// extracted by mini-css-extract-plugin
var _1 = "SecondaryMenu-moduleSecondaryMenu__sTwFH MenuItems-moduleMenuItems__Km6SD";
export { _1 as "SecondaryMenu" }
